<ng-template #dialogEnterCountryAndZipCode let-data>
  <ds-modal>
    <ds-modal-header [hideCloseButton]="true">
      <h3 i18n="@@payment.express_checkout.countryAndZipCodeDialog.title">Adressdaten zur Steuerberechnung.</h3>
    </ds-modal-header>

    <p class="mb-3" i18n="@@payment.express_checkout.countryAndZipCodeDialog.message">
      Zur Berechnung der MwSt. wählen Sie bitte das Land, in dem Sie wohnen. Bei Versandprodukten wählen Sie bitte das
      Lieferland. Bitte achten Sie darauf, dass das Land mit dem in Ihrem Google- oder Apple-Pay Account hinterlegten
      Land übereinstimmt.
    </p>

    <orderform-inputs-generator
      #countryAndZipcodeInput
      id="countryAndZipcodeInput"
      (dataChanges)="taxAddressData$.next($event)"
      [data]="orderStateShippingAddress$ | async"
      [fields]="fieldsConfig$ | async"
      [attr.data-e2e]="'form:address:shipping'"
    ></orderform-inputs-generator>

    <div *ngIf="isExpressCheckoutInitiable$ | async" class="bg-info p-3">
      <span i18n="@@payment.express_checkout.countryAndZipCodeDialog.total">Gesamt (inkl. MwSt.):</span>
      <span class="text-bold">{{ totalOrderAmount$ | async | currency }}</span>
    </div>

    <ds-spinner size="10" [color]="IconColor.Primary400"></ds-spinner>

    <ds-modal-footer>
      <div class="button-container d-flex justify-content-end">
        <button type="button" class="ds-button secondary mr-2" mat-dialog-close i18n="@@button.cancel">
          Abbrechen
        </button>

        <div class="position-relative">
          <div id="stripe-express-checkout-dialog-{{ uniqueInstanceId }}"></div>
          <div
            *ngIf="!(isExpressCheckoutInitiable$ | async)"
            class="express-checkout-button-disable-overlay position-absolute w-100 h-100"
          >
            <ds-spinner *ngIf="orderStateUpdating$ | async" size="10" [color]="IconColor.Primary400"></ds-spinner>
          </div>
        </div>
      </div>
    </ds-modal-footer>
  </ds-modal>
</ng-template>

<ng-template #dialogUpdatedTaxApproval let-data>
  <ds-modal>
    <ds-modal-header [hideCloseButton]="true">
      <h3 i18n="@@payment.express_checkout.countryAndZipCodeDialog.not_charged">Ihnen wurde noch nichts berechnet</h3>
    </ds-modal-header>

    <p class="mb-3" i18n="@@payment.express_checkout.countryAndZipCodeDialog.recalculated_taxes"
      >Auf Basis der gespeicherten Adresse in Ihrem Apple/Google Pay Konto haben wir den MwSt.-Betrag erneut berechnet
      und den Gesamtbetrag wie folgt aktualisiert.</p
    >

    <p class="mb-0" i18n="@@payment.express_checkout.countryAndZipCodeDialog.original_address"
      >Bisherige Adressangabe:</p
    >
    <p class="mb-3 text-bold"> {{ data.oldAddress }} </p>

    <p class="mb-0" i18n="@@payment.express_checkout.countryAndZipCodeDialog.updated_address">Aktualisierte Adresse:</p>
    <p class="mb-3 text-bold"> {{ data.newAddress }} </p>

    <div class="bg-info p-3">
      <span i18n="@@payment.express_checkout.countryAndZipCodeDialog.total">Gesamt (inkl. MwSt.):</span>
      <span class="text-bold">{{ totalOrderAmount$ | async | currency }}</span>
    </div>

    <ds-modal-footer>
      <div class="button-container d-flex justify-content-end">
        <button type="button" class="ds-button secondary mr-2" mat-dialog-close i18n="@@button.cancel">
          Abbrechen
        </button>

        <button
          type="button"
          class="ds-button primary mr-2 text-white"
          [mat-dialog-close]="true"
          i18n="@@orderform.buy_now"
          >Jetzt kaufen</button
        >
      </div>
    </ds-modal-footer>
  </ds-modal>
</ng-template>

<ng-template #dialogOrderSummary let-data>
  <ds-modal>
    <ds-modal-header [hideCloseButton]="true">
      <div class="header">
        <h3 i18n="@@payment.express_checkout.orderSummary.title" class="text-center m-0"
          >Letzter Schritt zum Abschluss Ihrer Bestellung</h3
        >
        <ds-icon class="mr-2.5 icon-close" size="24" [name]="IconName.DialogClose" mat-dialog-close></ds-icon>
      </div>
    </ds-modal-header>

    <orderform-buy-summary
      layout="vertical"
      outerContainerClasses="pgb-border-shadow-no-shadow"
      innerContainerClasses="pgb-border-shadow-10-drop"
      title=""
      [expressCheckoutMode]="true"
    >
      <div
        *ngIf="paymentLegalHint$ | async as paymentLegalHint"
        class="buy-button-legal-notice"
        [innerHTML]="paymentLegalHint"
      ></div>
      <div
        *ngIf="(isGift$ | async) === true"
        class="buy-button-legal-notice buy-button-order-gift-notice"
        i18n="@@buy_button.buy-verification.buy-button-order-gift-notice"
        >Die Bestellung ist ein Geschenk. Sie können nach der Zahlung eine Grußnachricht und das Datum für den Erhalt
        des Geschenks festlegen.
      </div>
    </orderform-buy-summary>
    <ds-modal-footer>
      <div class="button-container d-flex justify-content-center">
        <button
          type="button"
          class="ds-button primary mr-2 text-white custom-button"
          i18n="@@button.payNow"
          [mat-dialog-close]="true"
        >
          Jetzt kaufen
        </button>
      </div>
    </ds-modal-footer>
  </ds-modal>
</ng-template>

<div style="min-width: 235px" class="position-relative">
  <div id="stripe-express-checkout-{{ uniqueInstanceId }}"></div>
  <div
    *ngIf="(orderStateUpdating$ | async) || (isFreePurchase$ | async)"
    class="express-checkout-button-disable-overlay position-absolute w-100 h-100"
  >
    <ds-spinner *ngIf="orderStateUpdating$ | async" size="10" [color]="IconColor.Primary400"></ds-spinner>
  </div>
  <div *ngIf="(validationAmount | async)?.amount > 0" class="validationAmountHint mt-2 text-left text-secondary">
    <i class="fa fa-info-circle"></i>
    <span i18n="@@payment.express_checkout.validation_hint">
      Your card may be authorized for
      {{ (validationAmount | async)?.amount | currency : (validationAmount | async)?.currency : 'symbol' }}, but no
      charge will be made at this time.
    </span>
  </div>
  <div *ngIf="['error', 'refused'].includes((paymentStatus$ | async)?.status)" class="text-center alert alert-danger">
    <span i18n="@@payment.express_checkout.payment_error_message"
      >Die Zahlung konnte nicht durchgeführt werden. Bitte versuchen Sie es erneut.</span
    >
  </div>
</div>
